import axios, { getVariable } from "./api";
import { getCorretAnswers } from "./respostas";
import { getPerguntas } from "./perguntas";
import { closeGlobalPopup, globalPopup } from "./popup";
import { keycloak } from "../components/auth";
import { updateUserLS, setUser } from "./user";

export const getHistoricoPartida = async (idUsuario, themeSlug) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) +
      "/historicopartida/" +
      idUsuario +
      "/" +
      themeSlug,
    headers
  );
};

export const setPartida = async (partida) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };
  if (!window.OFFLINE.isOffline) {
    return axios.post(
      (await getVariable("CONHECIGAME_API")) + "/setmatch/" + partida.id,
      partida,
      headers
    );
  } else {
    window.OFFLINE.stack.push({
      action: "setPartida",
      params: partida,
    });

    localStorage.setItem("OFFLINE_STACK", JSON.stringify(window.OFFLINE.stack));
  }
};

export const removerDesbloqueios = () => {
  window.GLOBALS.savedMatches.map((item) => {
    if (item && item.status !== undefined && item.status === "blocked") {
      item.status = "suspended";
      item.scoreLife = window.CONFIG.single.scoreMaxLives;
      // Atualizar a tabela no BD de blocked -> suspended
      let dadosPartida = {
        id: item.match_id,
        invitation_user: window.GLOBALS.user.info.user_id,
        challenged_user: -1,
        match_active: 2,
        match_type: "S",
        match_winner_id: null,
      };

      setPartida(dadosPartida);
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
    }

    return item;
  });

  return true;
};

export const initActualSingleMatch = () => {
  return Promise.resolve(
    (function () {
      window.GLOBALS.actualSingleMatch = JSON.parse(
        JSON.stringify(window.DEFAULT.actualSingleMatch)
      );

      // Pega do config as configurações de partida que podem sofrer alterações via admin
      window.GLOBALS.actualSingleMatch.totalScoreLife =
        window.CONFIG.single.scoreMaxLives;
      window.GLOBALS.actualSingleMatch.scoreLife =
        window.CONFIG.single.scoreMaxLives;

      for (let i = 0; i < 30; i++) {
        window.GLOBALS.actualSingleMatch.questions[i] = {
          respondeu: false,
          acertou: false,
          dificuldade: "",
        };
      }

      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

      return window.GLOBALS;
    })()
  );
};

export const calcularAcertos = (usuario_trilha, item_trilha, theme_id) => {
  let user_id = window.GLOBALS.user.info.user_id;

  return getCorretAnswers(user_id, theme_id).then((data) => {
    //TODO: obter total de acertos
    window.parent.postMessage(
      {
        method: "updateGameResult",
        usuario_trilha: usuario_trilha,
        item_trilha: item_trilha,
        acertos: data.correct_answers,
      },
      "*"
    );
  });
};

export const startNewMatch = (theme_id, indexC, indexT, tipoJ, new_game) => {
  // Let' get new questions
  getPerguntas(theme_id, new_game).then((perguntas) => {
    window.GLOBALS.actualSingleMatch.questions = perguntas;
    // salva dados partida
    let dadosPartida = {
      id: -1,
      invitation_user: window.GLOBALS.user.info.user_id,
      challenged_user: -1,
      match_active: 1,
      match_type: "S",
      match_winner_id: null,
      theme_id: theme_id,
    };

    let totalAnswers = countQuestionsResponded();

    setPartida(dadosPartida).then((data) => {
      window.GLOBALS.actualSingleMatch.match_id = data.data.insertId;

      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

      if (!new_game && totalAnswers >= 30) {
        definirFluxoDesafioCompleto(theme_id, indexC, indexT, tipoJ);
      } else {
        gotoListaPerguntasCtrl(perguntas, indexC, indexT, tipoJ);
      }
    });
  });
};

export const definirFluxoDesafioCompleto = (
  theme_id,
  indexC,
  indexT,
  tipoJ,
  props
) => {
  let correct = countQuestionsCorrect();
  let totalQuestions = window.GLOBALS.actualSingleMatch.questions.length;

  let percentual = correct ? Math.floor((correct / totalQuestions) * 100) : 0;

  updateUserLS({
    user_match_points:
      window.GLOBALS.user.info.user_match_points +
      window.GLOBALS.actualSingleMatch.scorePoints,
  });
  setUser(
    Object.assign(window.GLOBALS.user.info, {
      cpf: window.GLOBALS.user.info.user_cpf,
    })
  );

  // registrarMoedas(correct).then((res) =>
  //   console.log("moedas registradas", res)
  // );

  if (percentual > 75) {
    globalPopup(
      "Resultado do Jogo",
      true,
      [
        {
          texto: "Não",
          acao: () => {
            closeGlobalPopup();
          },
        },
        {
          texto: "Sim",
          acao: () => {
            startNewMatch(theme_id, indexC, indexT, tipoJ, true);
          },
        },
      ],
      "Parabéns! Você acertou " +
        percentual +
        "% do questionário, deseja jogar novamente?"
    );
  } else {
    globalPopup(
      "Resultado do Jogo",
      true,
      [
        {
          texto: "Ok",
          acao: () => {
            window.GLOBALS.savedMatches[indexT] = undefined;
            initActualSingleMatch();
            startNewMatch(theme_id, indexC, indexT, tipoJ, true);
            localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
            closeGlobalPopup();
            if (props !== null && props !== undefined) {
              props.history.push("/tab/single/" + indexC + "/" + indexT);
            }
          },
        },
      ],
      "Você acertou " + percentual + "% do questionário! O Jogo será reiniciado"
    );
  }

  localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
};

export const checkNext = (theme_id, indexC, indexT, tipoJ) => {
  getCorretAnswers(
    window.GLOBALS.user.info.user_id,
    theme_id,
    window.GLOBALS.actualSingleMatch.match_id
  ).then((data) => {
    let totalAnswers = countQuestionsResponded();

    if (totalAnswers >= 30) {
      definirFluxoDesafioCompleto(theme_id, indexC, indexT, tipoJ);
    } else {
      gotoListaPerguntasCtrl(
        window.GLOBALS.actualSingleMatch.questions,
        indexC,
        indexT,
        tipoJ
      );
    }
  });
};

export const gotoListaPerguntasCtrl = (questoes, indexC, indexT, tipoJ) => {
  window.GLOBALS.actualSingleMatch.questions = questoes;
  window.GLOBALS.savedMatches[indexT] = {};

  localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
};

export const registrarMoedas = async (totalAcertos) => {
  window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));

  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.post(
    (await getVariable("CONHECIGAME_API")) + "/registercoins",
    {
      total_acertos: totalAcertos,
      usuario_trilha: parseInt(window.GLOBALS.usuario_trilha),
      item_trilha: parseInt(window.GLOBALS.item_trilha),
    },
    headers
  );
};

export const countQuestionsResponded = () => {
  let answared = 0;

  for (let i in window.GLOBALS.actualSingleMatch.questions) {
    let q = window.GLOBALS.actualSingleMatch.questions[i];
    if (q.respondeu) answared++;
  }

  return answared;
};

export const countQuestionsCorrect = () => {
  let answared = 0;

  for (let i in window.GLOBALS.actualSingleMatch.questions) {
    let q = window.GLOBALS.actualSingleMatch.questions[i];
    if (q.acertou) answared++;
  }

  return answared;
};
